import React from 'react';
import { MapPin, Phone, Sparkles } from 'lucide-react';
import { site } from '../data/site';
export function Hero() {
  return <section id="top" className="w-full border-b border-sky-100 bg-sky-50/70" data-id="element-78" data-mp="ej4pg2ybuli3">
      <div className="mx-auto grid w-full max-w-6xl gap-14 px-6 py-20 md:py-28 lg:grid-cols-[1.05fr_1fr] lg:items-center" data-id="element-79" data-mp="9k0bkz0gjzlf">
        <div data-id="element-80" data-mp="4na0yr7f9w7e">
          <p className="inline-flex items-center gap-2 rounded-full bg-[#1D4ED8] px-4 py-1.5 text-[11px] font-medium uppercase tracking-[0.2em] text-white" data-id="element-81" data-mp="4jm4bj6oktog">
            <MapPin className="h-3.5 w-3.5" aria-hidden="true" data-id="element-82" data-mp="xa4e131wttau" />
            {site.location}
          </p>

          <h1 className="mt-6 text-4xl font-semibold leading-[1.08] tracking-tight text-[#0B2A6B] sm:text-5xl lg:text-6xl" data-id="element-83" data-mp="sa9slf0wlvx6">
            Crystal clear views,
            <span className="block text-[#1D4ED8]" data-id="element-84" data-mp="3d1im5e7m7kpj">every time.</span>
          </h1>

          <p className="mt-6 max-w-md text-base leading-relaxed text-slate-600" data-id="element-85" data-mp="3cz5u28857tyr">
            Professional residential and commercial window cleaning by {site.owner}. Careful
            work, fair pricing, and glass you forget is there.
          </p>

          <div className="mt-10 flex flex-col gap-3 sm:flex-row" data-id="element-86" data-mp="3o6ki7px9iq8t">
            <a href={site.phoneHref} className="inline-flex items-center justify-center gap-2 rounded-full bg-[#1D4ED8] px-7 py-3.5 text-sm font-medium text-white transition-colors hover:bg-[#0B2A6B]" data-id="element-87" data-mp="39alaige2es47">
              <Phone className="h-4 w-4" aria-hidden="true" data-id="element-88" data-mp="30h9djxcskbpe" />
              Call {site.phone}
            </a>
            <a href="#contact" className="inline-flex items-center justify-center gap-2 rounded-full border border-[#1D4ED8]/30 bg-white px-7 py-3.5 text-sm font-medium text-[#1D4ED8] transition-colors hover:border-[#1D4ED8]" data-id="element-89" data-mp="35aasu6gwud9i">
              <Sparkles className="h-4 w-4" aria-hidden="true" data-id="element-90" data-mp="2hix1o3uhwnq4" />
              Request a free quote
            </a>
          </div>

          <ul className="mt-10 flex flex-wrap gap-2" data-id="element-91" data-mp="2lk8qw89gj6xs">
            {site.badges.map(badge => <li key={badge} className="rounded-full border border-sky-200 bg-white px-3.5 py-1.5 text-[11px] uppercase tracking-[0.18em] text-[#0B2A6B]" data-id="element-92" data-mp="s3mf683jc910">
                {badge}
              </li>)}
          </ul>
        </div>

        <div className="relative" data-id="element-93" data-mp="degiorw30wwt">
          <div className="absolute -left-4 -top-4 hidden h-24 w-24 rounded-full bg-sky-200/60 lg:block" data-id="element-94" data-mp="dbaqv4w2jgxe" />
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/07b90353-c6ef-4925-8e4b-6119ccde2d32.jpg" alt="Window cleaner using a squeegee on a large glass facade" className="relative aspect-[4/3] w-full rounded-sm object-cover" loading="eager" data-id="element-95" data-mp="161t24t6y4olw" />
        </div>
      </div>
    </section>;
}